export const errorMessage = {
  setLost: "Veuillez choisir un niveau de perte",
  setFranchise: "Veuillez choisir un niveau de franchise",
  setLostAndFranchise: "Veuillez choisir les niveaux de perte et de franchise",
};
